export default {
  departments: {
    searchDepartments: 101792, // Search Departments
  },
};
